import FLUX_RENEW_PASSWORD_CONSTANTS from './../constants/renewPassword-constants';
import { Dispatch } from 'redux';
import { API } from '../api/renewPassword-api';
import * as types from '../types/renewPassword-types';
import RenewPasswordModel from '../../models/RenewPassword/renewPassword-Model';
import { sendNewPasswordEmail } from '../../services/email/email';
import { EmailTemplates } from '../../services/email/EmailTemplates';

const renewPasswordBegin = (): types.IUserRenewPasswordBegin => {
    return {
        type: FLUX_RENEW_PASSWORD_CONSTANTS.USER_RENEW_PASSWORD_BEGIN
    }
}

const renewPasswordError = (e: any): types.IUserRenewPasswordError => {
    return {
        type: FLUX_RENEW_PASSWORD_CONSTANTS.USER_RENEW_PASSWORD_ERROR,
        error: e
    }
}

const renewPasswordSuccess = (): types.IUserRenewPasswordSuccess => {
    return {
        type: FLUX_RENEW_PASSWORD_CONSTANTS.USER_RENEW_PASSWORD_SUCCESS
    }
}

const clearIsSendSuccess = (): types.IUserRenewPasswordClear => {
    return {
        type:FLUX_RENEW_PASSWORD_CONSTANTS.USER_RENEW_PASSWORD_CLEAR,
        payload: false
    }
}

//----------SEND NEW RANDOM PASSWORD----------//
export const renewPassword = (data: RenewPasswordModel, passwordWithSpaces: string) => {
    const { email } = data.user;
    return (dispatch: Dispatch) => {
        dispatch(renewPasswordBegin());

            API.renewPassword(data).then((response:any) => {
            dispatch(renewPasswordSuccess());

            ///Email js///
            sendNewPasswordEmail(email, passwordWithSpaces, EmailTemplates.RenewPassword).then((response) => {
                return true;

            }).catch((error) => {
                return false;
            })
            
        }).catch((errors: any) => {
            dispatch(renewPasswordError(errors.response.data.errors));  
        })
    }
}

//---------------CLEAR VARIABLES------------//
export const clearIsSend = () => {
    return (dispatch: Dispatch) => {
        dispatch(clearIsSendSuccess());
    }
}